module.exports = __webpack_public_path__ + "static/media/IMG_5490.1cadf9e7.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_5490.PNG
// module id = 553
// module chunks = 0